Vue.use(vant.Button).use(vant.Toast).use(vant.Dialog);
